import { memoize, uniqueByKey } from "@ls/js-utils";
import { createSelector } from "reselect";
import SelectionState from "state/selections/SelectionState";
import PivotDefinition from "./PivotDefinition";
import scope from "./scope";

export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return (state) => state[scope]["definitions"][selectionState];
  }

  return createSelector<any, PivotDefinition[]>(
    (state) => state[scope]["definitions"][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(
        ({ complete }) => complete
      );
      return completeDefinitions.filter(
        uniqueByKey(completeDefinitions, "key")
      );
    }
  );
});
